import httpService from "./http.service"

const authService = {
  getClientAuthCode: async (phone, recaptchaToken) => {
    const { data } = await httpService.post("api/clients/auth-code", {
      phone,
      recaptchaToken,
    })
    return data
  },
  createNewClient: async (phone, userId) => {
    await httpService.post("api/clients/register/", { phone, userId })
  },
  clientLogin: async (phone, code) => {
    const { data } = await httpService.post("api/clients/login", { phone, code })
    return data
  },
  userLogin: async (phone, password, recaptchaToken) => {
    const { data } = await httpService.post("api/users/login", {
      phone,
      password,
      recaptchaToken,
    })
    return data
  },
  userRegister: async ({ phone, password, companyId, recaptchaToken }) => {
    const { data } = await httpService.post("api/users/register", {
      phone,
      password,
      companyId,
      recaptchaToken,
    })
    return data
  },
}

export default authService
